import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseSvcService } from './config/base-svc.service';
import { SessionService } from './session.service';
import { IGetCodes, IGetCodesName, IStudyUnitPracticeTest } from '../interfaces/codes';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppOfflineStore } from '../app.offlineService';
import { map } from 'rxjs/operators';
import { IExtractedStudyUnit, IStudyunitPracticeTestQuestion } from '../interfaces/practiceTest';
import { IQuestionForMockExam } from './exam-management/exam-management.service';

export interface IGetStudyUnitPracticeTestPayload {
  LoggedInUser?: string
  SessionLanguageTypeCode?: string
  SubjectID: number
  ScreenName: string
  CourseTestID?: number |null
  CourseID: number
  CoursePlanID?: any
  SelectedInd?: any
}

export interface IAddEditPraticeTestPayload {
  LoggedInUser: string
  CourseId: number
  CourseTestId: any
  StudentId: any
  StudyUnitID: any
  TestTypeCode: string
  TestName: string | null
  TestSequenceNumber: any
  TotalScore: number
  CourseTestStatusTypeCode: string
  NewCourseTestId: any
  ErrorMessage?: any
  SuccessInd?: any
  ExamSeriesTypeCode?: string | null
  NumberOfQuestions:number;
  UDTStudyUnitPracticeTestApplicableCoursePlan: UdtstudyUnitPracticeTestApplicableCoursePlan[]
}

export interface UdtstudyUnitPracticeTestApplicableCoursePlan {
  CoursePlanID: number
  SelectedInd: string
}


export interface IGetQuestionForStudyMaterialPracticeTestPayload{
  LoggedInUser?: string
  CourseId: number
  CourseTestId: number
  NumberOfQuestions: number
  QuestionID: any
}


@Injectable({
  providedIn: 'root'
})
export class StudyunitPracticeTestService {
  BASEURL: string = environment.apiBaseUrl;
  LOGGED_IN_USER: string = this.session.getUser();
  private selectedPracticeTestId$ = new BehaviorSubject<number | null>(null);
  constructor(
    private http: HttpClient,
    private config: BaseSvcService,
    public session: SessionService,
    public appser: AppOfflineStore,
  ) { }

  setSelectedPracticeTestId(id: number | null) {
    this.selectedPracticeTestId$.next(id);
  }
  getSelectedPracticeTestId() {
    return this.selectedPracticeTestId$.asObservable();
  }

  getCurrentSelectedPracticeTestId() {
    return this.selectedPracticeTestId$.value;
  }

  getSubject(code?: string): Observable<IGetCodesName[]> {
    const endpoint = code?.trim()
      ? `${this.BASEURL}/api/GetCodes/SUBJECT@${code}`
      : `${this.BASEURL}/api/GetCodes/SUBJECT`;
    return this.http.get<any>(
      endpoint
    ).pipe(map((res: any) => {
      return res.resultList as IGetCodesName[];
    }));
  }

  getStudyUnitPracticeTestApplicableCoursePlan(payload:IGetStudyUnitPracticeTestPayload):Observable<IStudyUnitPracticeTest[]>{
    payload.SessionLanguageTypeCode=this.appser.userlanuage;
    payload.LoggedInUser= this.session.getUser();
   return this.http.post<IStudyUnitPracticeTest[]>(`${this.BASEURL}/api/GetStudyUnitPracticeTestApplicableCoursePlan`,payload).pipe(map((res:any)=>res?.PracticeTestApplicableCoursePlans))
  }


  addEditStudyUnitPracticeTest(paylaod:IAddEditPraticeTestPayload){
    return this.http.post(`${this.BASEURL}/api/InsertOrUpdateCourseTestForStudyUnitPracticeTest`,paylaod)
  }


  getStudyUnitPracticeTestQuestion(payload:{
    LoggedInUser?: string
    CourseTestId: number
    CourseTestStatusTypeCode: string |null
  }):Observable<IExtractedStudyUnit[]>{
    payload.LoggedInUser= this.session.getUser();
    return this.http.post<IExtractedStudyUnit[]>(`${this.BASEURL}/api/GetStudyUnitPracticeTestQuestion`,payload) .pipe(map((e: any) => this.ExtractPracticeQuestion(e.Questions)));
  }


  GetQuestionForStudyMaterialPracticeTest
  (payload:IGetQuestionForStudyMaterialPracticeTestPayload):Observable<any[]>{
    payload.LoggedInUser= this.session.getUser();
    return this.http.post<any[]>(`${this.BASEURL}api/GetQuestionForStudyMaterialPracticeTest`,payload).pipe(map((e: any) => this.ExtractQuestionsForMockExam(e.Questions)));
  }




  ExtractPracticeQuestion(apiResponse: IStudyunitPracticeTestQuestion[]) {
    const studyUnitMap = new Map<number, any>();

    apiResponse.forEach((item) => {
      if (!studyUnitMap.has(item.Study_Unit_Id)) {
        studyUnitMap.set(item.Study_Unit_Id, {
          Study_Unit_Id: item.Study_Unit_Id,
          Study_Unit_Name: item.Study_Unit_Name,
          Total_Number_Of_Question: item.Total_Number_Of_Question,
          Current_Number_Of_Question: item.Current_Number_Of_Question,
          Study_Unit_Current_Number_Of_Question: item.Study_Unit_Current_Number_Of_Question,
          isCollapsed: false,
          questions: new Map<number, any>()
        });
      }
      // Handle questions
      if (item.Question_ID) {
        const studyUnit = studyUnitMap.get(item.Study_Unit_Id);
        if (!studyUnit.questions.has(item.Question_ID)) {
          studyUnit.questions.set(item.Question_ID, {
            Path_Name: item.Path_Name,
            Question_ID: item.Question_ID,
            Question_Text: item.Question_Text,
            Answer_Choices: []
          });
        }
        studyUnit.questions.get(item.Question_ID).Answer_Choices.push({
          Answer_Choice_Sequence_Number: item.Answer_Choice_Sequence_Number,
          Answer_Choice_Id: item.Answer_Choice_Id,
          Answer_Choice_Text: item.Answer_Choice_Text,
          Right_Answer_Ind: item.Right_Answer_Ind,
          All_Of_The_Above_Or_None_Of_The_Above_Ind: item.All_Of_The_Above_Or_None_Of_The_Above_Ind,
          Selected_IND: item.Selected_IND,
        });
      }
    });

    // Convert Map to array and flatten questions map as array
    return Array.from(studyUnitMap.values()).map((studyUnit) => {
      studyUnit.questions = Array.from(studyUnit.questions.values());
      return studyUnit;
    });
  }


  ExtractQuestionsForMockExam(apiResponse: IQuestionForMockExam[]) {
    const QuestionMap = new Map();
    apiResponse.forEach((item) => {
      if (!QuestionMap.has(item.Question_ID)) {
        QuestionMap.set(item.Question_ID, {
          Path_Name: item.Path_Name,
          Question_ID: item.Question_ID,
          Question_Text: item.Question_Text,
          Answer_Choices: [],
          SelectedQuestion: false,
          Number_Of_Answer_Choices: item.Number_Of_Answer_Choices,
          Right_Answer_Default_Score: item.Right_Answer_Default_Score,
          RightAnswerDefaultScore: item.Right_Answer_Default_Score,
          Wrong_Answer_Penalty_Default_Score:
            item.Wrong_Answer_Penalty_Default_Score,
          WrongAnswerPenaltyDefaultScore:
            item.Wrong_Answer_Penalty_Default_Score,
          Time_To_Answer_In_Seconds: item.Time_To_Answer_In_Seconds,
          TimeToAnswerInSeconds: item.Time_To_Answer_In_Seconds,
          Total_Number_Of_Optional_Questions:
            item.Total_Number_Of_Optional_Questions,
        });
      }
      QuestionMap.get(item.Question_ID).Answer_Choices.push({
        Answer_Choice_Id: item.Answer_Choice_Id,
        Answer_Choice_Text: item.Answer_Choice_Text,
        Right_Answer_Ind: item.Right_Answer_Ind,
        All_Of_The_Above_Or_None_Of_The_Above_Ind:
          item.All_Of_The_Above_Or_None_Of_The_Above_Ind,
        Answer_Selected_IND: item.Answer_Selected_IND,
        selected: item.Right_Answer_Ind === 'Y' ? true : false,
      });
    });
    return Array.from(QuestionMap.values()).map((question) => {
      return question;
    });
  }

}
